import { Avatar, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { ref, set } from "firebase/database";
import { realtimeDb } from "../utils/firebase";
import { Spinner } from "./spinner/Spinner";
import { IProduct } from "../types/types";
import { useProducts } from "../hooks/useProducts";
import { BottomSheet } from "./BottomSheet";
import { normalizePolish } from "../utils/normlizePolish";

export const AddNewProductPopup = ({ open, setOpen }: { open: boolean, setOpen: (value: boolean) => void }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [products, setProducts] = useState<IProduct[]>([]);
  const [searchValue, setSearchValue] = useState("");
  const { products: localProducts } = useProducts();

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  useEffect(() => {
    if (searchValue.trim().length < 3) return;

    const timeoutId = setTimeout(async () => {
      setLoading(true);
      setError("");

      try {
        const result = await fetch("https://frisco-meal-order-api.vercel.app/api/products", {
          method: "POST",
          headers: { "content-type": "application/json" },
          body: JSON.stringify({ search: searchValue })
        });
        const data = await result.json();
        setProducts(data);
      } catch {
        setError("Nie udało się pobrać produktów");
      } finally {
        setLoading(false);
      }
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [searchValue]);

  const handleAddProduct = async (product: {}) => {
    setLoading(true)

    const productId = normalizePolish((product as IProduct).name);

    try {
      await set(ref(realtimeDb, `products/${productId}`), product);
    } catch {
      setError("Nie udało się dodać produktu");
    } finally {
      setLoading(false);
    }
  };

  return (
    <BottomSheet height={60} isOpen={open} handleClose={handleClose} handleOpen={handleOpen}>
      <>
        <TextField
          id="search-input"
          fullWidth
          label="Wyszukaj produkt"
          variant="outlined"
          onChange={(e) => setSearchValue(e.target.value)}
          value={searchValue}
          error={!!error}
        />
        {loading ? <div style={{ marginTop: 250 }}><Spinner size={70} /></div> : (
          <ul style={{ listStyle: "none", paddingLeft: 0, height: "100%", overflow: "auto", paddingBottom: 46, marginTop: 16 }}>
            {products.filter((product) => !localProducts.map(({ productId }) => productId).includes(product.productId)).map((product) => {
              return (
                <li key={product.name} onClick={() => handleAddProduct(product)} style={{ marginBottom: 4 }}>
                  <div style={{ display: "flex", gap: 4, alignItems: "center", justifyContent: "space-between" }}>
                    <div style={{ display: "flex", gap: 4, alignItems: "center" }}>
                      {product.imageUrl && <Avatar slotProps={{ root: { style: { background: "#fff" } }, img: { style: { objectFit: "contain" } } }} alt={product.name} src={product.imageUrl} variant="rounded" />}
                      <Typography sx={{ textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", maxWidth: 235 }}>{product.name}</Typography>
                    </div>
                    <Typography>{product.capacity} {product.unit}</Typography>
                  </div>
                </li>
              )
            })}
          </ul>
        )}

        {error && <Typography color="error">{error}</Typography>}
      </>
    </BottomSheet>
  )
}
